'use client';

import { QueryProvider } from '@/components/providers/query-provider';
import { SessionProvider } from '@/hooks/use-session';
import dynamic from 'next/dynamic';
import { NuqsAdapter } from 'nuqs/adapters/next';

interface ProvidersProps {
  children: React.ReactNode;
}

function ProvidersComponent({ children }: ProvidersProps) {
  return (
    <QueryProvider>
      <NuqsAdapter>
        <SessionProvider>{children}</SessionProvider>
      </NuqsAdapter>
    </QueryProvider>
  );
}

export const Providers = dynamic(() => Promise.resolve(ProvidersComponent), {
  ssr: false,
  loading: () => null
});
